export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const SIGNUP_CONFIRM_EMAIL_REQUEST = 'SIGNUP_CONFIRM_EMAIL_REQUEST';
export const SIGNUP_CONFIRM_EMAIL_SUCCESS = 'SIGNUP_CONFIRM_EMAIL_SUCCESS';
export const SIGNUP_CONFIRM_EMAIL_FAILURE = 'SIGNUP_CONFIRM_EMAIL_FAILURE';

export const SIGNIN_REQUEST = 'SIGNIN_REQUEST';
export const SIGNIN_FAILURE = 'SIGNIN_FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const CHECK_FORGOT_PASSWORD_KEY_REQUEST = 'CHECK_FORGOT_PASSWORD_KEY_REQUEST';
export const CHECK_FORGOT_PASSWORD_KEY_SUCCESS = 'CHECK_FORGOT_PASSWORD_KEY_SUCCESS';
export const CHECK_FORGOT_PASSWORD_KEY_FAILURE = 'CHECK_FORGOT_PASSWORD_KEY_FAILURE';

export const SET_NEW_PASSWORD_REQUEST = 'SET_NEW_PASSWORD_REQUEST';
export const SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD_FAILURE = 'SET_NEW_PASSWORD_FAILURE';


// WEBPACK FOOTER //
// ./src/features/Auth/types.js